import React from "react";
import {
  Tag,
  Button,
  Avatar,
  DatePicker,
  Space,
  Select,
  Input,
  Modal,
  message,
} from "antd";
import { message as messageApi, order as orderApi, property as propertyApi } from "../../apis";
import {
  PageContainer,
  PageHeader,
  PageContent,
} from "../../components/Layout";
import { MyTable, RowAction } from "../../components";
import { useHistory, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Filter } from "../../components/Design";
import usePermission from "../../hooks/usePermission";
import moment from "moment";
import styled from "styled-components";
import { useTranslate } from "../../hooks";
import { dateFormat, renderUser } from "../../utils";
import { ExclamationCircleOutlined, SearchOutlined, PlusOutlined } from "@ant-design/icons";
import useFetch from "../../hooks/useFetch";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { Row, Col, Checkbox, DatePicker as AntDatePicker } from "antd";
import { Divider, NumberInput, Select as MantineSelect } from "@mantine/core";
import { CalendarIcon, XMarkIcon } from "@heroicons/react/24/solid";
import NewCalendarForm from "../../components/Calendar/NewCalendarForm";
import dayjs from "dayjs";

const userName = (user) => {
  if (user) {
    return (
      <Space>
        {user?.type === "PERSONAL" ? (
          <div>
            <b>{user?.lastName}</b>
            <b>{user?.firstName}</b> <br />
          </div>
        ) : (
          <div>
            <b>{user?.orgname}</b> <br />
          </div>
        )}
      </Space>
    );
  }
  return <Space>{"ユーザー見つかりません"}</Space>;
};

export const renderStatus = (status, translate) => {
  if (status === "NEW")
    return (
      <Tag color="blue">
        {translate(`system.orderstatus.${status}`, status)}
      </Tag>
    );
  if (status === "PAID")
    return (
      <Tag color="green">
        {translate(`system.orderstatus.${status}`, status)}
      </Tag>
    );
  if (status === "CHAT")
    return (
      <Tag color="blue">
        {translate(`system.orderstatus.${status}`, status)}
      </Tag>
    );
  if (status === "PENDING")
    return (
      <Tag color="orange">
        {translate(`system.orderstatus.${status}`, status)}
      </Tag>
    );
  if (status === "TRANSFER")
    return (
      <Tag color="orange">
        {translate(`system.orderstatus.${status}`, status)}
      </Tag>
    );
  if (status === "CANCELLED")
    return (
      <Tag color="red">
        {translate(`system.orderstatus.${status}`, status)}
      </Tag>
    );
  if (status === "CLOSED")
    return (
      <Tag color="gray">
        {translate("orderstatus.archive.closed", "クローズ")}
      </Tag>
    );
  if (status === "UNNECESSARY")
    return (
      <Tag color="gray">
        {translate("orderstatus.archive.unnecessary", "不要")}
      </Tag>
    );
  if (status === "DONE")
    return (
      <Tag color="green">
        {translate("orderstatus.archive.done", "実施済み")}
      </Tag>
    );
};

export default () => {
  const { translate } = useTranslate();
  const history = useHistory();
  const myTableRef = React.useRef();
  const params = useParams();
  const { s3host, roles, orderStatuses } = useSelector(
    (state) => state.general
  );
  const { isConversation } = useSelector((state) => state.socket);
  const { token } = useSelector((state) => state.auth);
  const currentUserId = React.useMemo(() => {
    if (!token) return null;
    try {
      return JSON.parse(atob(token.split(".")[1])).uid;
    } catch {
      return null;
    }
  }, [token]);
  const [properties] = useFetch(propertyApi.selectAdminActives)([]);
  const { search } = useLocation();
  const didInit = React.useRef(false);
  const paramsSearch = React.useMemo(
    () => new URLSearchParams(search),
    [search]
  );
  const { checkPermission } = usePermission();
  const savedFilters = JSON.parse(sessionStorage.getItem("chatFilters") || "{}");
  const [tablePage, setTablePage] = React.useState(
    parseInt(paramsSearch.get("page") ?? savedFilters.page ?? "1", 10)
  );
  const [tableLimit, setTableLimit] = React.useState(
    parseInt(paramsSearch.get("limit") ?? savedFilters.limit ?? "10", 10)
  );
  const getDate = (paramValue, savedValue) => {
    if (paramValue) return new Date(paramValue);
    if (savedValue) return new Date(savedValue);
    return undefined;
  };

  const [filters, setFilters] = React.useState({
    query       : paramsSearch.get("query") ?? savedFilters.query ?? "",
    userIdQuery : paramsSearch.get("userIdQuery") ?? savedFilters.userIdQuery ?? "",
    startDate   : getDate(paramsSearch.get("startDate"), savedFilters.startDate),
    endDate     : getDate(paramsSearch.get("endDate"), savedFilters.endDate),
    propertyId  : paramsSearch.get("propertyId") ?? savedFilters.propertyId,
    status      : paramsSearch.get("status") ?? savedFilters.status,
    useStartDate: paramsSearch.get("useStartDate") ?? savedFilters.useStartDate,
    useEndDate  : paramsSearch.get("useEndDate") ?? savedFilters.useEndDate,
    useDateSort : paramsSearch.get("useDateSort") ?? savedFilters.useDateSort ?? "",
  });

  const [query, setQuery] = React.useState(filters.query);
  const [userIdQuery, setUserIdQuery] = React.useState(filters.userIdQuery);
  const [copyModal, setCopyModal] = React.useState(false);
  const [copyData, setCopyData] = React.useState(null);
  const [copyLoading, setCopyLoading] = React.useState(false);
  const [copySelectedDateRange, setCopySelectedDateRange] = React.useState([]);
  const [copyDisabledDates, setCopyDisabledDates] = React.useState([]);
  const [copyGahaiError, setCopyGahaiError] = React.useState([false, false]);
  const debounceRef = React.useRef();

  const columns = useHeader({
    translate,
    s3host,
    roles,
    renderStatus,
    type    : params.type,
    checkPermission,
    currentUserId,
    onAction: async (key, record) => {
      switch (key) {
        case "detail": {
          history.push(`/chat/${record._id}`);
          break;
        }
        case "copy": {
          const res = await messageApi.get(record._id);
          setCopyData(res);
          setCopyDisabledDates(res?.property?.unavailableDates);
          setCopySelectedDateRange([{
            startDate: res?.order?.startDate,
            endDate  : res?.order?.endDate,
          }]);
          setCopyModal(true);
          break;
        }
        case "archive": {
          Modal.confirm({
            title  : translate("system.list.model.title", "Confirm"),
            icon   : <ExclamationCircleOutlined />,
            content: translate(
              record.isArchive
                ? "chat.list.modal.content2"
                : "chat.list.modal.content",
              "Would you like to archive/sunarchive this chat?"
            ),
            okText    : translate("income.list.modal.oktext", "Verify"),
            cancelText: translate("system.list.modal.canceltext", "Cancel"),
            onOk      : async () => {
              try {
                await messageApi.archive(record._id);
                myTableRef.current.reload();
              } catch (err) {
                console.log(err);
              }
            },
          });
          break;
        }
        default:
      }
    },
  });

  React.useEffect(() => {
    if (!didInit.current) return;
    const params = new URLSearchParams();

    if (filters.query) params.set("query", filters.query);
    if (filters.userIdQuery) params.set("userIdQuery", filters.userIdQuery);
    if (filters.startDate)
      params.set("startDate", filters.startDate.toISOString());
    if (filters.endDate) params.set("endDate", filters.endDate.toISOString());
    if (filters.propertyId) params.set("propertyId", filters.propertyId);
    if (filters.status) params.set("status", filters.status);
    if (filters.useStartDate) params.set("useStartDate", filters.useStartDate);
    if (filters.useEndDate) params.set("useEndDate", filters.useEndDate);
    if (filters.useDateSort) params.set("useDateSort", filters.useDateSort);
    params.set("page", tablePage);
    params.set("limit", tableLimit);

    sessionStorage.setItem("chatFilters", JSON.stringify({ ...filters, page: tablePage, limit: tableLimit }));
    history.replace({ search: params.toString() });
  }, [filters, tablePage, tableLimit]);

  React.useEffect(() => {
    if (!didInit.current) return;
    if (filters.query === query && filters.userIdQuery === userIdQuery) return;
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      setTablePage(1);
      setFilters((state) => ({ ...state, query, userIdQuery }));
    }, 300);
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, [query, userIdQuery]);

  React.useEffect(() => {
    if (!didInit.current) return;
    setQuery("");
    setUserIdQuery("");
    setFilters({
      query       : "",
      userIdQuery : "",
      startDate   : undefined,
      endDate     : undefined,
      useStartDate: undefined,
      useEndDate  : undefined,
      propertyId  : undefined,
      status      : undefined,
    });
  }, [params.type]);

  React.useEffect(() => {
    if (!didInit.current) return;
    setFilters({
      ...filters,
      startDate: undefined,
      endDate  : undefined,
    });
  }, [isConversation]);

  React.useEffect(() => {
    didInit.current = true;
  }, []);

  const statusDateFilter = (e) => {
    setTablePage(1);
    setFilters({
      ...filters,
      useStartDate: e && moment(e[0]).startOf("days").toDate(),
      useEndDate  : e && moment(e[1]).endOf("days").toDate(),
    });
  };

  const copyOrder = async () => {
    if (copySelectedDateRange?.length < 1) {
      message.error(translate("system.regex.required", "Required"));
      return;
    }
    setCopyLoading(true);
    try {
      await messageApi.copy({
        orderId  : copyData?.order?._id,
        startDate: moment(copySelectedDateRange[0].startDate).format("YYYY-MM-DD"),
        endDate  : moment(copySelectedDateRange[0].endDate).format("YYYY-MM-DD"),
      });
      message.success(translate("order.copy.success", "New inquiry created!"));
      setCopyModal(false);
      setCopyLoading(false);
      myTableRef.current.reload();
    } catch (error) {
      message.error(error?.message || translate("system.request.failed", "failed!"));
      setCopyLoading(false);
    }
  };
  const getDates = (startDate, endDate) => {
    const daysbetween = Math.floor((Date.parse(startDate) - Date.parse(endDate)) / 86400000) - 1;
    const dates = Array(-daysbetween || 0).fill("");
    return dates?.map((date, index) => {
      if (index === 0) return startDate;
      if (index === -daysbetween) return endDate;
      return moment(startDate, "YYYY-MM-DD").add(index, "days");
    });
  };

  const deleteCopyItem = (indexs, item) => {
    let array = copySelectedDateRange.filter((_, index) => index !== indexs);
    setCopySelectedDateRange(array);
    const res = getDates(item.startDate, item.endDate).map((item) =>
      moment(item)?.format("YYYY/MM/DD")
    );
    setCopyDisabledDates(copyDisabledDates.filter((val) => !res.includes(val)));
  };
  const onClear = () => {
    setTablePage(1);
    setQuery("");
    setUserIdQuery("");
    setFilters({
      query       : "",
      userIdQuery : "",
      startDate   : undefined,
      endDate     : undefined,
      useStartDate: undefined,
      useEndDate  : undefined,
      propertyId  : undefined,
      status      : undefined,
      useDateSort : "",
    });
  };

  return (
    <PageContainer>
      <PageHeader title={translate("chat.list.title", "Chat")}
        extra={[
          <Button
            key="create-order"
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => history.push("/chat/create-order")}
          >
            {translate("admin.order.create", "問い合わせ作成")}
          </Button>,
        ]}
      />
      <PageContent>
        <Filter
          extra={[
            <DatePicker.RangePicker
              value={[
                filters.useStartDate && moment(filters.useStartDate),
                filters.useEndDate && moment(filters.useEndDate),
              ]}
              onChange={statusDateFilter}
              placeholder={[
                translate("chat.history.useDate.start", "利用日から"),
                translate("chat.history.useDate.end", "利用日まで"),
              ]}
            />,
            <Select
              value={filters.useDateSort }
              style={{ width: "100px" }}
              onChange={(e) => setFilters({ ...filters, useDateSort: e })}
              placeholder={"表示順"}
            >
              <Select.Option key={2} value={""}>
                なし
              </Select.Option>
              <Select.Option key={1} value={"ASC"}>
                昇順
              </Select.Option>
              <Select.Option key={2} value={"DESC"}>
                降順
              </Select.Option>
            </Select>,
            <Button onClick={onClear}>
              {translate("system.filter.btn.clear", "Clear")}
            </Button>,
          ]}
        >
          <Select
            showSearch
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            style={{ width: 300 }}
            value={filters.propertyId}
            onChange={(e) => {
              setTablePage(1);
              setFilters({ ...filters, propertyId: e });
            }}
            placeholder={translate("income.list.select.property", "Property ")}
            allowClear
            options={properties.map((item) => {
              return {
                value: item._id,
                label: item.name,
              };
            })}
          ></Select>
          <Input
            className="grid-item"
            prefix={<SearchOutlined />}
            value={userIdQuery}
            placeholder={translate(
              "system.input.search.userId",
              "ユーザー名、ユーザーID"
            )}
            onChange={(e) => setUserIdQuery(e.target.value)}
            allowClear
          />
          <Input
            className="grid-item"
            prefix={<SearchOutlined />}
            value={query}
            placeholder={translate(
              "system.input.search.orderid",
              "Search by order id..."
            )}
            onChange={(e) => setQuery(e.target.value)}
            allowClear
          />
          <Select
            className="grid-item"
            value={filters.status}
            style={{ width: "130px" }}
            onChange={(e) => {
              setTablePage(1);
              setFilters({ ...filters, status: e });
            }}
            placeholder={translate("order.list.filter.status", "Order status")}
            allowClear
          >
            {orderStatuses.map((type, index) => (
              <Select.Option key={index} value={type}>
                {translate(`system.orderstatus.${type}`, type)}
              </Select.Option>
            ))}
            <Select.Option key={"archive"} value={"ARCHIVE"}>
              {translate("system.orderstatus.ARCHIVE", "Archive")}
            </Select.Option>
          </Select>
        </Filter>
        <Table
          ref={myTableRef}
          columns={columns}
          filters={filters}
          loadData={messageApi.list}
          rowKey={(record) => record?.rowKey}
          page={tablePage}
          onPageChange={setTablePage}
          limit={tableLimit}
          onLimitChange={setTableLimit}
        />
        <Modal
          centered
          width={700}
          title={translate("order.details.modal.copy", "Copy inquiry")}
          open={copyModal}
          onCancel={() => setCopyModal(false)}
          onOk={copyOrder}
          confirmLoading={copyLoading}
        >
          <WrapperContent>
            <Row gutter={[16, 16]}>
              <Col className="firstCalendarItem" span={14}>
                <NewCalendarForm
                  minRange={copyData?.property?.minimumDay}
                  minRequired={copyData?.property?.minRequired}
                  gahaiError={setCopyGahaiError}
                  setDisable={setCopyDisabledDates}
                  setRange={setCopySelectedDateRange}
                  disabledDates={[
                    ...(copyDisabledDates || []),
                    ...getDates(
                      copySelectedDateRange[0]?.startDate,
                      copySelectedDateRange[0]?.endDate
                    ).map((c) => moment(c).format("YYYY/MM/DD")),
                  ]}
                  isBalai={true}
                />
              </Col>
              <Col className="dates" span={10}>
                {copySelectedDateRange?.map((item, index) => (
                  <div key={index} className="secondDateItem">
                    <CalendarIcon
                      style={{
                        width : "24px",
                        height: "24px",
                        color : "#f2670a",
                      }}
                    />

                    <div>
                      {dayjs(item.startDate).format("YYYY/MM/DD")} -
                      {dayjs(item.endDate).format("YYYY/MM/DD")}
                    </div>

                    <a
                      onClick={() => deleteCopyItem(index, item)}
                      style={{
                        display   : "flex",
                        alignItems: "center",
                      }}
                    >
                      <XMarkIcon style={{ width: "24px", height: "24px" }} />
                    </a>
                  </div>
                ))}
              </Col>
            </Row>
          </WrapperContent>
        </Modal>
      </PageContent>
    </PageContainer>
  );
};

const useHeader = ({ onAction, translate, renderStatus, currentUserId }) => {
  return [
    {
      title    : "№",
      dataIndex: "rowKey",
      width    : "20px",
    },
    {
      title : translate("system.useheader.title.owner", "Owner"),
      render: (row) => {
        return renderUser(row.owner);
      },
    },
    {
      title : translate("system.useheader.title.tenant.user", "ユーザー"),
      render: (row) => {
        return renderUser(row.tenant);
      },
    },
    {
      title : translate("system.useheader.title.tenant.userId", "User ID"),
      render: (row) => {
        return <Tag>{row.tenant?.userId}</Tag>;
      },
    },
    {
      title : translate("system.useheader.list.property", "Property"),
      render: (row) => {
        return (
          <Space>
            <Avatar size={45} shape="square" src={row?.property?.image} />
            <div>
              <b style={{}}>{row?.property?.name}</b> <br />
            </div>
          </Space>
        );
      },
    },
    {
      title : translate("system.useheader.title.orderid", "Order ID"),
      render: (record) => {
        return <Tag>{record?.order?.orderId}</Tag>;
      },
    },
    {
      title : translate("system.useheader.list.order.status", "Order status"),
      render: (record) => {
        return renderStatus(record.orderStatus, translate);
      },
    },
    {
      title : translate("chat.useheader.title.date", "Last chat date"),
      render: (record) => {
        return (
          <Space>
            {moment(record?.lastChatDate).format("YYYY/MM/DD HH:mm")}
            {(!record?.ownerSeen ||
              !record?.ownerSeen?.some((id) => id?.toString() === currentUserId)
            ) && (
              <Tag color="red">
                {translate("chat.list.date.tag", "new chat")}
              </Tag>
            )}
            <Tag>{userName(record?.lastChat?.user)}</Tag>
          </Space>
        );
      },
    },
    {
      title : translate("order.list.useheader.dates", "Dates"),
      render: (record) => {
        return (
          <Tag>{`${dateFormat(record?.order?.startDate)}-${dateFormat(
            record?.order?.endDate
          )}`}</Tag>
        );
      },
    },
    {
      title : translate("system.useheader.title.action", "Action"),
      width : 100,
      render: (record) => {
        const actions = {
          detail : translate("system.list.action.detail", "Detail"),
          copy   : translate("system.list.action.copy", "複製する"),
          archive: translate(
            record.isArchive
              ? "chat.list.action.unarchive"
              : "chat.list.action.archive",
            "Archive"
          ),
        };
        return (
          <RowAction
            actions={actions}
            onClick={(key) => onAction(key, record)}
          />
        );
      },
    },
  ];
};

const Table = styled(MyTable)`
  .ant-table-cell {
    padding: 8px;
    line-height: 15px;
  }
`;
const WrapperContent = styled.div`
  .dates {
    padding: 0px 0;
    display: flex;
    flex-direction: column;
    gap: 8px;

    .secondDateItem {
      border-radius: 4px 4px;
      border: 1px solid #e4e6ea;
      padding: 5px 10px;
      display: flex;
      gap: 8px;
      align-items: center;
      color: #8d8d8d;
      font-weight: 500;
    }
  }
  .gahaiError {
    margin-top: 15px;
    .gahaiError1 {
      border: 1px solid red;
      border-radius: 5px;
      padding: 5px;
      text-align: center;
      color: red;
    }
    .gahaiError2 {
      border: 1px solid red;
      border-radius: 5px;
      padding: 5px;
      text-align: center;
      color: red;
    }
    .gahaiError3 {
      border: 1px solid orange;
      border-radius: 5px;
      padding: 5px;
      text-align: center;
      color: orange;
    }
  }
`;